module.exports = __webpack_public_path__ + "static/banner-right-440a7e1de5ff53bf409f5ff2ae9a15a7.svg";